import "./QSUSA.css";
import { ignoreEnter, handleFigureChange, handleFigureBlur } from "./utils/inputhandlers";
// import { ignoreEnter, handleFigureChange, handleFigureBlur } from "./utils/inputhandlers";
import useUSQSUndo from "../../hooks/useUSQSUndo";
import useUSQS from "../../hooks/useUSQS";
import { useNavigate, useLocation } from "react-router-dom";

const USQSFormGroup = ({
  labelname,
  inputname,
  inputtype,
  style,
  readOnly,
  type,
  rowStyle,
  cplaceholder,
  required,
}) => {
  // General
  const navigate = useNavigate();
  // Load context data
  const { USQS, setUSQS, setUSQSData, inEuros, setInEuros } = useUSQS();
  const { USQSEdits, editIDUSQS, setEditIDUSQS, editingFieldUSQS, setEditingFieldUSQS, undoListUSQS, inputRefsUSQS } =
    useUSQSUndo();
  // Functions
  // const handleNavToUSPos = () => {
  //   navigate("/positions/usa", { state: { positiontoedit: USQS.WGP } });
  // };
  return (
    <div className='form-group' style={rowStyle}>
      <label>{labelname}:</label>
      {readOnly ? (
        <input
          readOnly
          disabled
          type={type || "text"}
          style={{ border: "none" }}
          autoComplete='off'
          onKeyDown={ignoreEnter}
          onFocus={(e) => e.target.select()}
          value={USQS?.[inputname] || ""}
          name={inputname}
          tabIndex={-1}
        />
      ) : (
        <input
          required={required === false ? false : true}
          type={type || "text"}
          name={inputname}
          value={USQS?.[inputname] ? USQS?.[inputname] : USQS?.[inputname] === 0 ? 0 : ""}
          autoComplete='off'
          onKeyDown={ignoreEnter}
          onFocus={(e) => e.target.select()}
          onChange={(e) =>
            handleFigureChange(
              e,
              inputtype,
              setUSQS,
              setUSQSData,
              setEditingFieldUSQS,
              inEuros,
              USQS?.exchangeRateUsdToEur
              //  inputtype === "currency" ? 2 : 4,
            )
          }
          onBlur={(e) =>
            handleFigureBlur(
              e,
              inputtype,
              setUSQS,
              USQSEdits,
              editIDUSQS,
              setEditIDUSQS,
              editingFieldUSQS,
              setEditingFieldUSQS,
              undoListUSQS,
              inEuros,
              USQS?.exchangeRateUsdToEur
            )
          }
          style={style}
          placeholder={cplaceholder}
          ref={(el) => (inputRefsUSQS.current[inputname] = el)}
        />
      )}
      {/* {USQS.qstype === 2 && inputname === "WGP" && USQS.WGP ? (
        <button type='button' onClick={() => handleNavToUSPos()}>
          Go
        </button>
      ) : (
        ""
      )} */}
    </div>
  );
};

export default USQSFormGroup;
